
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/faq",
      function () {
        return require("private-next-pages/tyres/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/faq"])
      });
    }
  